// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"552c4562","687":"d50df82a"}[chunkId] + ".chunk.js";
};